import { render } from "./App.vue?vue&type=template&id=f13d4d4c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f13d4d4c&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__